// JsFromRoutes CacheKey 4a4711adc0d5d54de11f852c1a27d711
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  list: definePathHelper('get', '/mass-draft'),
  copy: definePathHelper('get', '/deals/:id/copy'),
  complete: definePathHelper('put', '/deals/:id/complete'),
  publish: definePathHelper('put', '/deals/:id/publish'),
  access: definePathHelper('put', '/deals/:id/access'),
  new: definePathHelper('get', '/deals/new'),
  get: definePathHelper('get', '/deals/:id'),
  update: definePathHelper('patch', '/deals/:id'),
  destroy: definePathHelper('delete', '/deals/:id'),
}
